import * as XLSX from "xlsx";

export default {
  methods: {
    /**
     * HTMLテーブル要素からそのままExcel出力
     * @param {string} xlsx_name - 出力ファイル名（例: 'sample.xlsx'）
     * @param {string} table_id  - querySelector用のセレクタ（例: '#table-id'）
     */
    exceldownload(xlsx_name, table_id) {
      const elt = document.querySelector(table_id);
      const wb = XLSX.utils.table_to_book(elt, xlsx_name);
      XLSX.writeFile(wb, xlsx_name);
    },

    /**
     * 複数のHTMLテーブルから複数シートのExcelを出力
     * @param {string} xlsx_name - 出力ファイル名
     * @param {Array<[string, string]>} sheetArray - [セレクタ, シート名] の配列
     */
    exceldownload2(xlsx_name, sheetArray) {
      // ワークブックを作成
      const wb = XLSX.utils.book_new();

      sheetArray.forEach(element => {
        // テーブルデータを取得
        const elt = document.querySelector(element[0]);
        // シートを作成
        const sheet = XLSX.utils.table_to_sheet(elt);
        // ワークブックにシートを追加
        XLSX.utils.book_append_sheet(wb, sheet, element[1]);
      });

      // XLSXファイルを出力
      XLSX.writeFile(wb, xlsx_name);
    },

    /**
     * Vueのデータ（配列）からExcel出力するヘルパー
     *
     * @param {string} xlsx_name - 出力ファイル名（例: 'error_list.xlsx'）
     * @param {Array<Object>} rows - 出力対象データ（例: this.filterItems）
     * @param {Array<{ value: string, text?: string, label?: string }>} columns
     *   v-data-table の headers 相当。value: 行オブジェクトのキー, text/label: Excelの見出し
     * @param {string} [sheetName='Sheet1'] - シート名
     *
     * 使用例:
     *  this.exceldownloadFromData(
     *    'mlit_error.xlsx',
     *    this.filterItems,
     *    [
     *      { value: 'manage_no', text: '管理番号' },
     *      { value: 'office_no', text: '事業所番号' },
     *      { value: 'warehouse_no', text: '倉庫番号' },
     *      { value: 'branch', text: '区画番号' },
     *      { value: 'branch_name', text: '区画名称' },
     *      { value: 'type', text: '類別' },
     *      { value: 'volume', text: '面積' },
     *    ],
     *    'エラー一覧'
     *  );
     */
    exceldownloadFromData(xlsx_name, rows, columns, sheetName = "Sheet1") {
      if (!Array.isArray(rows) || rows.length === 0) return;
      if (!Array.isArray(columns) || columns.length === 0) return;

      // rows(=this.filterItemsなど) から、Excel用のオブジェクト配列を作成する
      const data = rows.map(row => {
        const record = {};

        columns.forEach(col => {
          // ヘッダ名（Excelの1行目の見出し）
          const header =
            col.text ||
            col.label ||
            col.value ||
            "";

          if (!header) return;

          // 行データから値を取得
          record[header] = row[col.value];
        });

        return record;
      });

      // JSON → Worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Workbook 作成 & シート追加
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);

      // ファイル出力
      XLSX.writeFile(wb, xlsx_name);
    },
  },
};
